<template>
  <div class="hello">
    <h1
      class="title is-size-2-widescreen is-size-4-mobile is-size-3-tablet has-text-weight-light pb-3"
    >
      The
      <span class="has-text-weight-bold">M2 Agency</span> specializes in
      <span class="has-text-weight-bold">Event Marketing</span>,
      <span class="has-text-weight-bold">Digital Promotion</span>,
      <span class="has-text-weight-bold">Radio Promotions</span>,
      <span class="has-text-weight-bold">Sports Marketing</span>,and
      <span class="has-text-weight-bold">Consulting</span>
    </h1>
    <h2 class="subtitle is-size-4-desktop is-size-5-mobile">
      With two decades of experience and proven results, let us take your
      campaign to the next level!
    </h2>
  </div>
</template>
<script>
export default {
  name: "HelloWorld",
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
